import styled from 'styled-components';

const LightTheme = styled.div.attrs({
  'data-theme': 'light',
})``;

export default LightTheme;
